import React from 'react';
import { LoadingSpinner } from 'components/shadcn/ui/loadingSpinner';

const HGSpinner = (props) => {
    return (
        <div
            className={`flex min-h-[10vh] items-center justify-center ${props.className}`}
        >
            <LoadingSpinner className="h-10 w-10" />
        </div>
    );
};

export default HGSpinner;
